/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {AutomationdataSettings} from './AutomationdataSettings';
import {DataAutomation} from './DataAutomation';

/**
 * The DataAutomationPipeline model module.
 * @module model/DataAutomationPipeline
 * @version 1.0.0
 */
export class DataAutomationPipeline {
  /**
   * Constructs a new <code>DataAutomationPipeline</code>.
   * @alias module:model/DataAutomationPipeline
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>DataAutomationPipeline</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DataAutomationPipeline} obj Optional instance to populate.
   * @return {module:model/DataAutomationPipeline} The populated <code>DataAutomationPipeline</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DataAutomationPipeline();
      if (data.hasOwnProperty('_id'))
        obj._id = ApiClient.convertToType(data['_id'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('tags'))
        obj.tags = ApiClient.convertToType(data['tags'], ['String']);
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('dataAutomations'))
        obj.dataAutomations = ApiClient.convertToType(data['dataAutomations'], [DataAutomation]);
      if (data.hasOwnProperty('settings'))
        obj.settings = AutomationdataSettings.constructFromObject(data['settings']);
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} _id
 */
DataAutomationPipeline.prototype._id = undefined;

/**
 * @member {String} title
 */
DataAutomationPipeline.prototype.title = undefined;

/**
 * @member {String} description
 */
DataAutomationPipeline.prototype.description = undefined;

/**
 * @member {Array.<String>} tags
 */
DataAutomationPipeline.prototype.tags = undefined;

/**
 * @member {Boolean} enabled
 */
DataAutomationPipeline.prototype.enabled = undefined;

/**
 * @member {Array.<module:model/DataAutomation>} dataAutomations
 */
DataAutomationPipeline.prototype.dataAutomations = undefined;

/**
 * @member {module:model/AutomationdataSettings} settings
 */
DataAutomationPipeline.prototype.settings = undefined;

/**
 * @member {String} created
 */
DataAutomationPipeline.prototype.created = undefined;

/**
 * @member {String} updated
 */
DataAutomationPipeline.prototype.updated = undefined;

